import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

/**
 * Restored Bluezone brand palette (previous site colours)
 * with mild polish via CSS — not a colour-system rewrite.
 */
export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#000000',
        secondary: '#025bbf',
        accent: '#025bbf',
        error: '#b71c1c',
        info: '#025bbf',
        success: '#2e7d32',
        warning: '#ed6c02',
        blue: '#335c39',
      },
      dark: {
        primary: '#ffffff',
        secondary: '#4ea1ff',
        accent: '#4ea1ff',
        error: '#ef5350',
        info: '#4ea1ff',
        success: '#66bb6a',
        warning: '#ffa726',
        blue: '#81c784',
      },
    },
  },
});
